import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { RevealLines } from "@/components/Reveal";

const CATS = ["All", "Womenswear", "Menswear", "Unisex"];

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/products", { params: cat === "All" ? {} : { category: cat } })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [cat]);

  return (
    <div className="pt-[72px]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-16 md:pt-24">
        <p className="overline mb-4">The Collection · 2026</p>
        <RevealLines tag="h1" immediate lines={["The", "Collection"]} className="font-serif text-7xl md:text-[9rem] leading-[0.82] tracking-tighter text-bone" />

        <div className="flex flex-wrap gap-3 mt-12 border-b border-line pb-8">
          {CATS.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`filter-${c.toLowerCase()}`}
              className={`px-6 py-2 border font-mono text-xs uppercase tracking-widest transition-colors duration-300 ${
                cat === c ? "bg-bone text-ink border-bone" : "border-line text-ash hover:text-bone hover:border-bone"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16 mt-16 pb-10">
          {loading
            ? Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[3/4] bg-ink-800 animate-pulse" />)
            : products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
        {!loading && products.length === 0 && (
          <p className="font-serif text-3xl text-ash italic py-20">No pieces in this category yet.</p>
        )}
      </div>
    </div>
  );
};

export default Shop;
